/** @jsx jsx */
import { jsx } from "theme-ui"
import Layout from '../components/layout'
import Seo from '../components/seo'
import { graphql } from 'gatsby'
import ProductCard from '../components/product-card'
import horizontal from '../../static/assets/wsb_horizontal_logo.png'

export const query = graphql`
  query AllProductQuery {
    allShopifyProduct {
      nodes {
        title
        productType
        description
        tags
        id
        handle
        images {
          originalSrc
          gatsbyImageData(width: 900, height: 900)
        }
        status
        variants {
          title
          shopifyId
          image {
            originalSrc
          }
          price
          availableForSale
          product {
            priceRangeV2 {
              maxVariantPrice {
                amount
                currencyCode
              }
              minVariantPrice {
                amount
                currencyCode
              }
            }
          }
        }

      }
    }
  }
`

export default function Shop({ data }) {
  return (
    <Layout className="shop-page"> 
      <Seo title="Shop" />
      <img 
        src={horizontal} 
        alt='Wheat Stalk Boutique' 
        sx={{
          width: '50%',
          display: 'block', 
          margin: 'auto'
        }}
      />
      <div 
        sx={{
          mx: 'auto',
          maxWidth: '90vw',
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
          gridGap: '1rem',
          my: '1rem'
        }}
      >
      {data.allShopifyProduct.nodes.map(product => (
            <ProductCard key={product.id} product={product} />
          ))}
      </div>
    </Layout>
  )
}



